import { createContext, type ReactNode, useContext } from 'react';

interface DialogContext {
    isOpen: boolean;
    isFullscreen?: boolean;
    onClose: VoidFunction;
}

const dialogContext = createContext<DialogContext | null>(null);

export const useDialogContext = () => {
    const context = useContext(dialogContext);

    if (!context) {
        throw new Error('Hook useDialogContext is used outside of DialogContext');
    }

    return context;
};

export const DialogProvider = (props: DialogContext & { children: ReactNode }) => {
    const { children, ...context } = props;

    return <dialogContext.Provider value={context}>{children}</dialogContext.Provider>;
};
